module.exports = "/assets/0111d098abfa75af5f6674ff9677fc3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BC.png
// module id = 1225
// module chunks = 0